import React from "react";
import { useTranslation } from "react-i18next";

/**
 * TriggerTypeCell Component
 * Displays the trigger type badge(s) for a data acquisition instance
 * Renders File Drop, Schedule, and/or Manual trigger indicators
 */
const TriggerTypeCell = ({ row }) => {
  const { t: translate } = useTranslation();

  return (
    <span
      className={`rounded-full flex items-end justify-start gap-1 w-full font-normal text-sm border border-r-10 border-transparent`}
    >
      {row.original.IsFileDrop && (
        <span>{translate("data-acquisition-instances.legend.fileDrop")}</span>
      )}
      {row.original.IsScheduleTrigger && (
        <span>{translate("data-acquisition-instances.legend.scheduled")}</span>
      )}
      {row.original.IsManualTrigger && (
        <span>{translate("data-acquisition-instances.legend.manual")}</span>
      )}
    </span>
  );
};

export default TriggerTypeCell;
